import React from 'react';

import Lozenge from '@atlaskit/lozenge';

import PullRequestLink from 'src/components/pull-request-link';
import { useIntl } from 'src/hooks/intl';
import { PullRequest } from 'src/types/pull-requests-table';

import { PrCycleMetrics } from './api/requests';
import { CycleTimeTooltip } from './cycle-time-tooltip';
import { messages } from './cycle-time.i18n';
import { MobileHiddenInlineBlock } from './cycle-time.style';

export type CycleTimeStaleLozengeProps = {
  stale?: boolean;
  pullRequest: PullRequest;
  cycleTimeMetrics?: PrCycleMetrics;
};

export const CycleTimeStaleLozenge = (props: CycleTimeStaleLozengeProps) => {
  const { pullRequest, stale, cycleTimeMetrics } = props;

  const intl = useIntl();

  if (!stale) {
    return null;
  }

  return (
    <MobileHiddenInlineBlock>
      <PullRequestLink
        title={pullRequest.title}
        href={pullRequest.links.html.href}
        disableNativeTooltip
      >
        <CycleTimeTooltip {...{ pullRequest, cycleTimeMetrics }}>
          <Lozenge appearance="moved">
            {intl.formatMessage(messages.pullRequestStaleLabel)}
          </Lozenge>
        </CycleTimeTooltip>
      </PullRequestLink>
    </MobileHiddenInlineBlock>
  );
};
